import { styled } from 'styled-components';

export const BaseFilePickerInputEl = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;

  &[disabled] {
    pointer-events: none;
    cursor: not-allowed;
  }
`;
